 ///sales agent dropdown styles
 export const styles = {
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      console.log({ data, isDisabled, isFocused, isSelected })
      return {
        ...styles,
        backgroundColor: isFocused ? "#e83e8c" : "white",
        marginRight: "6px",
        color: "black",
      }
    },
    indicatorSeparator: () => {}, // removes the "stick"
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      "& svg": { display: "none" },
    }),
    singleValue: (provided) => ({
      ...provided,
      height: "100%",
      paddingTop: "5px",
    }),
  }
 ///bank account dropdown styles
 export const style = {
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    option: (styles, { isFocused }) => {
      // console.log({ data, isDisabled, isFocused, isSelected })
      return {
        ...styles,
        backgroundColor: isFocused ? "#e83e8c" : "white",
        marginRight: "6px",
        color: "black",
        fontSize: "12px"
      }
    },
    singleValue: (provided) => ({
      ...provided,
      height: "100%",
      paddingTop: "5px",
    }),
  }


  //Pagination styles
 export const pagination = {
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    control: base => ({
      ...base,
      height: 40,
      minHeight: 40,
      backgroundColor: "#74788d",
    }),
    singleValue: (provided) => ({
      ...provided,
      height: "70%",
      marginRight: "5px",
      color: "white"
    }),
    multiValue: (provided) => ({
      ...provided,
     borderRadius: "5px"
    }),
    indicatorSeparator: () => {}, // removes the "stick"
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      "& svg": { marginLeft: "-10px", marginTop: "-5px" },
      color: "white"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      console.log({ data, isDisabled, isFocused, isSelected })
      return {
        ...styles,
        backgroundColor: isFocused ? "#e83e8c" : "white",
        marginRight: "6px",
        color: "black",
      }
    },
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: "white"
      }
    }
  }

    //venueLocationStyle
 export const venueLocationStyle = {
  control: base => ({
    ...base,
    height: 40,
    minHeight: 40
  }),
  singleValue: (provided) => ({
    ...provided,
    height: "70%",
    marginRight: "5px",
    color: "white"
  }),
  multiValue: (provided) => ({
    ...provided,
   borderRadius: "5px"
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    console.log({ data, isDisabled, isFocused, isSelected })
    return {
      ...styles,
      marginRight: "6px",
      color: "black",
      textTransform: "uppercase"
    }
  },
}

  //Paginations data

  export const dataPerPage = [
    {
      value: "5",
      label: "5",
    },
    {
      value: "10",
      label: "10",
    },
    {
      value: "15",
      label: "15",
    },
    {
      value: "20",
      label: "20",
    },
    {
      value: "25",
      label: "25",
    },
  ]